// Shared by GroupFormModal and RoleFormModal (design evaluation F41: the
// Create/Edit twins became one modal each, with the record as the mode).

export const KEY_PATTERN = /^[a-z0-9][a-z0-9-_]*$/;

export const KEY_PATTERN_MESSAGE =
  'Use lowercase letters, numbers, hyphens and underscores, starting with a letter or number';

// Suggested key from a name: lowercase, spaces to hyphens, other characters dropped.
export const keyFromName = (name: string) =>
  name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-_]/g, '')
    .replace(/-{2,}/g, '-')
    .replace(/^[-_]+/, '');

// The server's own reason, when it sent one.
export const apiErrorMessage = (err: unknown): string => {
  const e = err as { response?: { data?: { error?: string; message?: string } }; message?: string } | undefined;
  return e?.response?.data?.error || e?.response?.data?.message || e?.message || 'Unknown error';
};

/** Description for the payload. Blank stays omitted on create; on edit, an
 *  existing description the user cleared is sent as "" so it clears. */
export function descriptionField(raw: string | undefined, existing: string | undefined): { description?: string } {
  const description = raw?.trim();
  if (description) return { description };
  return existing ? { description: '' } : {};
}
